import React from 'react';
import { cross, loaderWhite } from '../../assets';

interface LaunchDialogProps {
  onClose: () => void;
}

const LaunchDialog: React.FC<LaunchDialogProps> = ({ onClose }) => {
  return (
    <section className="flex flex-col px-6 pt-6 pb-12 max-w-lg bg-white rounded-md border border-solid border-slate-300 max-md:px-5 z-50">
      <header className="flex flex-col items-end w-full text-2xl font-semibold leading-none text-center text-slate-900">
        <button onClick={onClose} aria-label="Close dialog">
          <img
            src={cross}
            alt=""
            className="object-contain w-6 aspect-square cursor-pointer"
            onClick={onClose}
          />
        </button>
        <h2 className="w-full max-md:max-w-full">
          Registering your contract on blockchain...
        </h2>
      </header>

      <div className="flex flex-col justify-center items-center pt-6 mt-4 w-full text-sm max-w-[464px] max-md:max-w-full">
        <div className="btn-primary flex gap-2 justify-center items-center px-4 py-2 font-medium leading-6 text-white rounded-md">
          <img
            src={loaderWhite}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-4 aspect-square animate-spin"
          />
          <span className="self-stretch my-auto">
            This may take 2-3 minutes.
          </span>
        </div>

        <p className="mt-6 w-full leading-5 text-center text-slate-500 max-md:max-w-full">
          Feel free to close this window. We'll notify you as soon as the
          process is complete.
        </p>
      </div>
    </section>
  );
};

export default LaunchDialog;
